module.exports = __webpack_public_path__ + "static/img/platform_advantages1.5d2dbf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/platform_advantages1.png
// module id = KHaA
// module chunks = 2